import { FC, ReactNode } from 'react'

import cls from './style.module.scss'

type AdvantagesProps = {
	items: {
		icon: ReactNode
		title: string
		subtitle: string
	}[]
}

export const Advantages: FC<AdvantagesProps> = ({ items }) => (
	<div className={cls.root}>
		{items.map(({ icon, title, subtitle }) => (
			<div key={title} className={cls.item}>
				{icon}
				<p className={cls.item__title}>{title}</p>
				<p className={cls.item__subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
			</div>
		))}
	</div>
)
